module.exports = __webpack_public_path__ + "static/media/chat-history.59f2e8a6.svg";